// extracted by css-extract-rspack-plugin
export default {"ViewButton":"fCHrO","medium":"u8rjv","onlyIcon":"PvhoE","active":"khSYX","label":"Qc6Rv"};